<header>
  <button class="close-button" mat-icon-button mat-dialog-close>
    <mat-icon fontIcon="close"></mat-icon>
  </button>
  <h3 class="color-white">{{ 'administration.email.headline' | translate }}</h3>
</header>
<mat-dialog-content>
  <form [formGroup]="form">
    <h4>{{ 'administration.email.description' | translate }}</h4>
    <div class="split-pane">
      <div class="split-pane-container">
        <mat-checkbox *ngIf="isUserVNB$ | async" color="accent" formControlName="location_mail">
          <mat-label>
            {{ 'administration.email.location_mail' | translate }}
          </mat-label>
        </mat-checkbox>
        <mat-checkbox *ngIf="(isUserC02Customer$ | async) || (isUserOGE$ | async)" color="accent" formControlName="co2_facility_mail">
          <mat-label>
            {{ getLocationMailCo2Label(isUserOGE$ | async) | translate }}
          </mat-label>
        </mat-checkbox>
        <mat-checkbox *ngIf="isUserAdmin$ | async" color="accent" formControlName="new_user_mail">
          <mat-label>
            {{ getNewUserMailLabel(isUserOGE$ | async) | translate }}
          </mat-label>
        </mat-checkbox>
        <mat-checkbox *ngIf="isUserH2Customer$ | async" color="accent" formControlName="location_changed_mail">
          <mat-label>
            {{ 'administration.email.location_changed' | translate }}
          </mat-label>
        </mat-checkbox>
        <mat-checkbox *ngIf="isUserOGE$ | async" color="accent" formControlName="new_vnb_mail">
          <mat-label>
            {{ 'administration.email.new_vnb' | translate }}
          </mat-label>
        </mat-checkbox>
      </div>
    </div>
  </form>
</mat-dialog-content>

<form [formGroup]="form">
  <mat-dialog-actions>
    <div></div>
    <button (click)="save()"
            [disabled]="!form.dirty"
            color="accent"
            mat-flat-button
            type="submit">
      {{ 'company_data.accept' | translate }}
    </button>
  </mat-dialog-actions>
</form>
